
(function(){
  function $(id){return document.getElementById(id);}
  var stage=$('dbStage'); if(!stage||!window.RD_LIGHTS) return;
  var LIGHTS={}; window.RD_LIGHTS.forEach(function(l){LIGHTS[l.id]=l;});
  var selL=$('dbSelL'), selR=$('dbSelR'), cL=$('dbCanvasL'), cR=$('dbCanvasR'),
      wrapR=$('dbWrapR'), handle=$('dbHandle'), labL=$('dbLabelL'), labR=$('dbLabelR');
  var pos=0.5;

  function krgb(k){ // approx kelvin -> warm/cool tint
    if(k<=3400) return [255,197,143];
    if(k<=4300) return [255,224,190];
    if(k<=5000) return [255,241,224];
    if(k<=5600) return [255,250,244];
    return [232,242,255];
  }
  function sim(s){
    var t=Math.min(1,(s.throwFt||400)/1900);
    var reach=0.42+0.5*Math.pow(t,0.6);
    var b=(s.beam||'').toLowerCase();
    var spread = (b.indexOf('fog')>=0||b.indexOf('flood')>=0)?0.46
               : b.indexOf('multi')>=0?0.34
               : (b.indexOf('hybrid')>=0||b.indexOf('driving')>=0)?0.26
               : b.indexOf('halogen')>=0?0.52 : 0.17;
    var lum=s.lumens||700;
    var intensity=Math.max(.22,Math.min(1,Math.log(lum)/Math.log(23000)));
    var hard = b.indexOf('spot')>=0?0.92 : b.indexOf('multi')>=0?0.72 : b.indexOf('hybrid')>=0||b.indexOf('driving')>=0?0.58 : b.indexOf('fog')>=0?0.32 : 0.34;
    return {reach:reach,spread:spread,intensity:intensity,hard:hard,rgb:krgb(s.kelvin||5500)};
  }
  function scene(ctx,W,H){
    // night sky + ground
    var g=ctx.createLinearGradient(0,0,0,H);
    g.addColorStop(0,'#0a0f1a'); g.addColorStop(.52,'#0b1220'); g.addColorStop(.54,'#0e0e10'); g.addColorStop(1,'#141416');
    ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
    // horizon glow
    var hg=ctx.createRadialGradient(W/2,H*.53,4,W/2,H*.53,W*.5);
    hg.addColorStop(0,'rgba(60,70,90,.22)'); hg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=hg; ctx.fillRect(0,0,W,H*.6);
    // road trapezoid (vanishing at center horizon)
    var hy=H*.54, vx=W/2;
    ctx.beginPath(); ctx.moveTo(W*.5-6,hy); ctx.lineTo(W*.5+6,hy); ctx.lineTo(W*.92,H); ctx.lineTo(W*.08,H); ctx.closePath();
    ctx.fillStyle='#17171a'; ctx.fill();
    // center dashes
    ctx.strokeStyle='rgba(200,190,120,.30)'; ctx.lineWidth=2;
    for(var i=0;i<9;i++){ var f0=i/9,f1=(i+.5)/9;
      ctx.beginPath();
      ctx.moveTo(vx,hy+(H-hy)*f0*f0); ctx.lineTo(vx,hy+(H-hy)*f1*f1); ctx.stroke();
      ctx.lineWidth=1+ f1*4;
    }
  }
  function beam(ctx,W,H,s){
    var hy=H*.54, ex=W/2, ey=H*1.02;                 // emitter just below frame
    var topY=hy+(H-hy)*(1-s.reach);                  // how far up the beam reaches
    var halfBottom=W*(0.10+s.spread*0.55);
    var halfTop=Math.max(6,W*(0.008+s.spread*0.10));
    ctx.save(); ctx.globalCompositeOperation='lighter';
    // cone clip
    ctx.beginPath(); ctx.moveTo(ex-halfTop,topY); ctx.lineTo(ex+halfTop,topY); ctx.lineTo(ex+halfBottom,H); ctx.lineTo(ex-halfBottom,H); ctx.closePath(); ctx.clip();
    var r=s.rgb, a=s.intensity;
    var lg=ctx.createLinearGradient(0,H,0,topY);
    lg.addColorStop(0,'rgba('+r[0]+','+r[1]+','+r[2]+','+(0.30*a)+')');
    lg.addColorStop(0.6,'rgba('+r[0]+','+r[1]+','+r[2]+','+(0.16*a)+')');
    lg.addColorStop(1,'rgba('+r[0]+','+r[1]+','+r[2]+',0)');
    ctx.fillStyle=lg; ctx.fillRect(0,topY,W,H);
    // hotspot (stronger + tighter for spot/high hardness), placed near the reach point
    var hsY=topY+(H-topY)*(0.30+0.35*(1-s.hard));
    var hsR=W*(0.06+ (1-s.hard)*0.22 + s.spread*0.15);
    var rg=ctx.createRadialGradient(ex,hsY,2,ex,hsY,hsR*(1.6));
    var hi=Math.min(0.95,0.42*a + 0.4*s.hard*a);
    rg.addColorStop(0,'rgba('+r[0]+','+r[1]+','+r[2]+','+hi+')');
    rg.addColorStop(0.5,'rgba('+r[0]+','+r[1]+','+r[2]+','+(hi*0.35)+')');
    rg.addColorStop(1,'rgba('+r[0]+','+r[1]+','+r[2]+',0)');
    ctx.fillStyle=rg; ctx.beginPath(); ctx.ellipse(ex,hsY,hsR*1.5,hsR*0.85,0,0,7); ctx.fill();
    ctx.restore();
    // soft source glow at bottom
    ctx.save(); ctx.globalCompositeOperation='lighter';
    var sg=ctx.createRadialGradient(ex,H,2,ex,H,W*0.12*(0.6+a));
    sg.addColorStop(0,'rgba('+r[0]+','+r[1]+','+r[2]+','+(0.5*a)+')'); sg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=sg; ctx.fillRect(0,H*.7,W,H*.3); ctx.restore();
  }
  function render(cvs,light){
    var dpr=Math.min(2,window.devicePixelRatio||1);
    var W=cvs.clientWidth, H=cvs.clientHeight;
    cvs.width=W*dpr; cvs.height=H*dpr;
    var ctx=cvs.getContext('2d'); ctx.setTransform(dpr,0,0,dpr,0,0);
    scene(ctx,W,H); if(light) beam(ctx,W,H,sim(light));
  }
  function chip(v){return v;}
  function fillSide(side,light){
    var lab= side==='L'?labL:labR;
    lab.innerHTML='<b>'+light.name+'</b><span>'+light.lumensLabel+' · '+light.beam+'</span>';
    render(side==='L'?cL:cR, light);
    updatePanels();
  }
  function specRow(k,l,r){ return '<tr><td>'+k+'</td><td>'+l+'</td><td>'+r+'</td></tr>'; }
  function updatePanels(){
    var L=LIGHTS[selL.value], R=LIGHTS[selR.value];
    var t=$('dbSpecTable');
    if(t){ t.innerHTML='<thead><tr><th>Spec</th><th>'+L.name+'</th><th>'+R.name+'</th></tr></thead><tbody>'+
      specRow('Effective output',L.lumensLabel,R.lumensLabel)+
      specRow('Beam pattern',L.beam,R.beam)+
      specRow('Reach @1 lux (approx)',L.throwFt+' ft',R.throwFt+' ft')+
      specRow('Power',L.watts,R.watts)+
      specRow('Price (each)',L.price?('$'+L.price):'n/a',R.price?('$'+R.price):'n/a')+
      '</tbody>'; }
    fb('dbFbL',L); fb('dbFbR',R);
  }
  function fb(id,l){
    var el=$(id); if(!el) return;
    var stars = l.rating? ('<div class="db-stars">★★★★★ <span>'+l.rating+'/5</span></div>') : '';
    var items=(l.feedback||[]).map(function(x){return '<li>'+x+'</li>';}).join('');
    var buy='';
    if(l.vid){ buy='<button class="gbtn db-buy" type="button" data-vid="'+l.vid+'" data-name="'+String(l.name).replace(/"/g,'&quot;')+'">Add to cart'+(l.price?(' \u00b7 $'+l.price):'')+'</button>'; }
    else if(l.buy){ buy='<a class="gbtn db-buy" href="'+l.buy+'">View '+l.name+'</a>'; }
    el.innerHTML='<h4>'+l.name+'</h4>'+stars+'<ul>'+items+'</ul>'+buy;
  }
  // draggable divider
  function setPos(p){ pos=Math.max(0.04,Math.min(0.96,p)); wrapR.style.clipPath='inset(0 0 0 '+(pos*100)+'%)'; handle.style.left=(pos*100)+'%'; }
  function drag(clientX){ var r=stage.getBoundingClientRect(); setPos((clientX-r.left)/r.width); }
  var dragging=false;
  handle.addEventListener('mousedown',function(e){dragging=true;e.preventDefault();});
  window.addEventListener('mousemove',function(e){if(dragging)drag(e.clientX);});
  window.addEventListener('mouseup',function(){dragging=false;});
  handle.addEventListener('touchstart',function(e){dragging=true;},{passive:true});
  window.addEventListener('touchmove',function(e){if(dragging&&e.touches[0])drag(e.touches[0].clientX);},{passive:true});
  window.addEventListener('touchend',function(){dragging=false;});
  stage.addEventListener('click',function(e){ if(e.target===handle) return; drag(e.clientX); });

  selL.addEventListener('change',function(){fillSide('L',LIGHTS[selL.value]);});
  selR.addEventListener('change',function(){fillSide('R',LIGHTS[selR.value]);});
  window.addEventListener('resize',function(){ fillSide('L',LIGHTS[selL.value]); fillSide('R',LIGHTS[selR.value]); });
  // add-to-cart (delegated; avoids inline-onclick quoting issues)
  document.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('.db-buy[data-vid]'):null;
    if(!b) return;
    e.preventDefault();
    var vid=parseInt(b.getAttribute('data-vid'),10);
    var nm=b.getAttribute('data-name')||'';
    if(window.addToCart){ window.addToCart(vid,nm); }
    else { fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})}).then(function(){location.href='/cart';}); }
    // in-place confirmation on the button itself
    if(!b.getAttribute('data-label')) b.setAttribute('data-label', b.textContent);
    b.classList.add('db-added'); b.textContent='\u2713 Added to cart';
    clearTimeout(b._t); b._t=setTimeout(function(){ b.textContent=b.getAttribute('data-label'); b.classList.remove('db-added'); }, 1700);
  });
  // init
  fillSide('L',LIGHTS[selL.value]); fillSide('R',LIGHTS[selR.value]); setPos(0.5);
})();
